/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvestmentAccountGetAllResponseFromDiscriminatorValue, serializeInvestmentAccountPostRequest, type InvestmentAccountGetAllResponse, type InvestmentAccountPostRequest } from '../models';
// @ts-ignore
import { type WithInvestmentAccountItemRequestBuilder, WithInvestmentAccountItemRequestBuilderNavigationMetadata, WithInvestmentAccountItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { OverviewRequestBuilderRequestsMetadata, type OverviewRequestBuilder } from './overview';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /investmentaccounts
 */
export interface InvestmentaccountsRequestBuilder extends BaseRequestBuilder<InvestmentaccountsRequestBuilder> {
    /**
     * The overview property
     */
    get overview(): OverviewRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.investmentaccounts.item collection
     * @param investmentAccountId The Guid identifier of the account to retrieve
     * @returns {WithInvestmentAccountItemRequestBuilder}
     */
     byInvestmentAccountId(investmentAccountId: Guid) : WithInvestmentAccountItemRequestBuilder;
    /**
     * Retrieves a list of all accounts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvestmentAccountGetAllResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvestmentAccountGetAllResponse[] | undefined>;
    /**
     * Creates a new account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: InvestmentAccountPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all accounts
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new account
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InvestmentAccountPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InvestmentaccountsRequestBuilderUriTemplate = "{+baseurl}/investmentaccounts";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const InvestmentaccountsRequestBuilderNavigationMetadata: Record<Exclude<keyof InvestmentaccountsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byInvestmentAccountId: {
        requestsMetadata: WithInvestmentAccountItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithInvestmentAccountItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["investmentAccountId"],
    },
    overview: {
        requestsMetadata: OverviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const InvestmentaccountsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvestmentaccountsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvestmentAccountGetAllResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: InvestmentaccountsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvestmentAccountPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
